module.exports = "pegasus/assets/theme2/small/5.jpg";